import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Award } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { translations, pickBilingual } from "../../lib/i18n";
import { TEST_IDS } from "../../constants/testIds";

const Education = ({ education = [] }) => {
  const { lang } = useLang();
  const t = translations[lang].education;

  return (
    <section
      id="education"
      data-testid={TEST_IDS.education.root}
      className="rp-section bg-[color:var(--rp-bg-2)]"
    >
      <div className="rp-container">
        <div className="mb-14 grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-6">
            <div className="rp-eyebrow mb-4">08 · {t.eyebrow}</div>
            <h2 className="rp-heading rp-headline">{t.title}</h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {education.map((item, i) => {
            const highlighted = item.highlighted;
            return (
              <motion.article
                key={item.id || i}
                data-testid={TEST_IDS.education.item(i)}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className={`rp-card p-8 md:p-10 ${
                  highlighted
                    ? "lg:col-span-12 border-[color:var(--rp-accent)]/40 bg-gradient-to-br from-[color:var(--rp-card)] to-[#1a1d21]"
                    : "lg:col-span-6"
                }`}
              >
                <div className="flex items-start gap-6">
                  <div
                    className={`w-12 h-12 flex items-center justify-center flex-shrink-0 border ${
                      highlighted ? "border-[color:var(--rp-accent)] text-[color:var(--rp-accent)]" : "border-white/15 text-white/70"
                    }`}
                  >
                    {highlighted ? <Award size={20} strokeWidth={1.5} /> : <GraduationCap size={20} strokeWidth={1.5} />}
                  </div>
                  <div className="flex-1 min-w-0">
                    {highlighted && (
                      <div className="text-[10px] tracking-[0.3em] uppercase text-[color:var(--rp-accent)] mb-3">
                        Pro License · Top qualification
                      </div>
                    )}
                    <h3
                      className={`font-display font-bold text-white leading-tight tracking-tight ${
                        highlighted ? "text-2xl md:text-3xl" : "text-lg md:text-xl"
                      }`}
                    >
                      {pickBilingual(item.title, lang)}
                    </h3>
                    <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-[12px] tracking-[0.14em] uppercase text-[color:var(--rp-muted)]">
                      <span>{item.institution}</span>
                      <span className="text-white/20">·</span>
                      <span>{item.date}</span>
                    </div>
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Education;
